export const REMOVE_PARTICIPANTS_FORM_KEY = 'participantIdsToBeRemoved'
